<app-data-table
  [title]="title"
  [dataSource]="dataSource"
  [defaultPageSize]="pageSize"
  (rowClicked)="onRowClicked($event)"
  [useDefaultSearch]="false"
  [additionalColumns]="additionalColumns"
  [useCalculatedMaxHeight]="true"
  [titleIcon]="'branding_watermark'"
  headerMargin="1rem"
  cardMargin="0">
  <ng-container class="card-header">
    <div class="header-actions">
      <button mat-raised-button color="primary" (click)="newContractClick()">
        <mat-icon>add</mat-icon>
          {{'BackOffice.ManageContracts.Contract.CreateButton' | translate: locale.language}}
      </button>
      <button mat-raised-button (click)="uploadContracts()" class="upload-button" [disabled]="loading()">
        <mat-icon>upload</mat-icon>
          {{'BackOffice.ManageContracts.Contract.UploadContract' | translate: locale.language}}
      </button>
      <button mat-raised-button (click)="exportContracts()" class="export-button" [disabled]="loading()">
        <mat-icon>download</mat-icon>
        {{'BackOffice.ManageContracts.Contract.DownloadContract' | translate: locale.language}}
      </button>
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="'BackOffice.ManageContracts.OtherActions' | translate: locale.language">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </ng-container>

  <ng-container class="additional-columns">
    <ng-container matColumnDef="delete" [stickyEnd]="true">
      <th class="delete-col" mat-header-cell *matHeaderCellDef></th>
      <td class="delete-cell" mat-cell *matCellDef="let data">
        @if (data.brandType !== 'System') {
          <button
            mat-icon-button
            (click)="onDeleteClick($event, data)"
            [matTooltip]="'BackOffice.ManageContracts.Contract.DeleteContract' | translate: locale.language"
            matTooltipPosition="before"
            [attr.aria-label]="'Delete contract for ' + data.tenantName">
            <mat-icon fontIcon="delete"></mat-icon>
          </button>
        }
      </td>
    </ng-container>
  </ng-container>
</app-data-table>
<mat-menu #menu="matMenu">
    <a mat-menu-item color="primary" [routerLink]="['/back-office/contracts/overages']" >
      <mat-icon>block</mat-icon>
      {{ 'BackOffice.ManageContracts.ContractOverages' | translate: locale.language }}
    </a>
</mat-menu>

